import React from 'react'

export const MembersBadge = () => {
    return (
        <div className="flex px-2 py-1 rounded-xl items-center bg-members-badge-pattern">
            <img width="14px" height="14px" src="./VIP-Badge-White.svg" />
            <div className="mr-1" />
            <p className="text-xs text-white font-normal">VIP Only</p>
        </div>
    )
}
